const NewInfoInput = ({ value, setValue }) => (
    <input className="appearance-none block w-full bg-white text-gray-700 border border-gray-300 rounded py-3 px-4 leading-tight focus:outline-none" type="text" value={value || ""} onChange={(e) => setValue(e.target.value)} />
)

export default NewInfoInput